import React from 'react';

import placeholder from '../../../assets/images/placeholder.png';
import bigOne from '../../../assets/images/big1.svg';
import bigTwo from '../../../assets/images/big2.svg';
import bigThree from '../../../assets/images/big3.svg';
import vip from '../../../assets/images/poker/home-footer.png';

const Mint = () => {
  return (
    <section className="pt-4 sm:pt-8 mint">
      <div className="w-full px-2 sm:px-5">
        <img
          className="mx-auto rounded-lg banner"
          src={vip}
          alt="mint a metafans"
          style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
        />
        <h1 className="hidden mt-4 sm:mt-10 mb-4 sm:mb-16 text-3xl font-bold text-center lt-white lg:text-4xl">
          Mint a MetaFan NFT
        </h1>
        <div className="flex flex-col hidden mt-2 sm:mt-5 lg:flex-row mint-list">
          <div className="flex items-center justify-center p-2 sm:p-5">
            <div>
              <img
                className="w-[3rem] lg:w-[4rem] xl:w-[4rem]"
                src={bigOne}
                alt="steps to minting a metafan"
              />
            </div>
            <p className="ml-2 sm:ml-5 -mt-2 sm:-mt-5 text-grey text-md md:text-lg">
              <span className="font-bold">
                Join the ultimate sports and poker club!
              </span>{' '}
            </p>
          </div>
          <div className="flex items-center justify-center p-2 sm:p-5 border-y-1 lg:my-0 lg:border-x-1 lg:border-y-0 border-textGrey">
            <div className="py-2 sm:py-5 lg:py-0">
              <img
                className="w-[3rem] lg:w-[4rem] xl:w-[4rem]"
                src={bigTwo}
                alt="steps to minting a metafan"
              />
            </div>
            <p className="py-2 sm:py-5 ml-2 sm:ml-5 -mt-2 sm:-mt-5 text-grey text-md md:text-lg lg:py-0">
              <span className="font-bold">
                Experience the holder benefits at sporting events and concerts!
              </span>{' '}
            </p>
          </div>
          <div className="flex items-center justify-center p-2 sm:p-5 mt-2 sm:mt-5 lg:mt-0">
            <div>
              <img
                className="w-[3rem] lg:w-[4rem] xl:w-[4rem]"
                src={bigThree}
                alt="steps to minting a metafan"
              />
            </div>
            <p className="ml-2 sm:ml-5 -mt-2 sm:-mt-5 text-grey text-md md:text-lg">
              <span className="font-bold">Additional Perks at Every Turn!</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mint;